/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CheckBoxLayoutEngine", ["LeafDynamicHeightLayoutEngine"], function (context, cls) {
  /**
   * @class CheckBoxLayoutEngine
   * @memberOf classes
   * @extends classes.LeafDynamicHeightLayoutEngine
   */
  cls.CheckBoxLayoutEngine = context.oo.Class(cls.LeafDynamicHeightLayoutEngine, function ($super) {
    return /** @lends classes.CheckBoxLayoutEngine.prototype */ {
      __name: "CheckBoxLayoutEngine",

      /**
       * @inheritDoc
       */
      _measure: function () {
        $super._measure.call(this);

        const layoutInfo = this._widget.getLayoutInformation();
        const measured = layoutInfo.getMeasured();
        if (measured.hasWidth(true)) {
          const checkboxBorderRight = cls.Size.translate(context.ThemeService.getValue("mt-field-focus-border-width-right"));
          const checkboxBorderLeft = cls.Size.translate(context.ThemeService.getValue("mt-field-focus-border-width-left"));
          const checkboxPadding = cls.Size.translate(context.ThemeService.getValue("gbc-CheckBoxWidget-padding"));

          // Add left/right border plus padding to avoid text clipping in measured width
          measured.setWidth(
            Math.ceil(measured.getWidth(true)) + (checkboxBorderRight + checkboxBorderLeft + checkboxPadding) * window.devicePixelRatio
          );
        }
      }
    };
  });
});
